/* eslint-disable import/prefer-default-export */
import log from '$$log';

export function reportWorkerError(errorEvent, source) {
  const message = errorEvent.message || `${errorEvent.filename || 'worker'}:${errorEvent.lineno || 0}`;
  const err = new Error(message);

  const filename = errorEvent.filename || 'worker';
  const lineno = errorEvent.lineno || 0;
  const colno = errorEvent.colno != null ? errorEvent.colno : 0;
  err.stack = `Error: ${message}\n    at onmessage (${filename}:${lineno}:${colno})`;
  err.workerSource = source;

  log.error(`[${source}]`, err);
}
